import React from 'react';
import OrderDirectionsEnum from '../../Enums/OrderDirectionsEnum';
import RoleService from '../../Services/roleService';
import moneyHelper from '../../Helpers/moneyHelper';
import FieldTypesEnum from '../../Enums/FieldTypesEnum';
import columnVisibilityHelper from '../../Helpers/columnVisibilityHelper';

export default function DataTableHeader(props) {
  const generateContent = (list, item) => {
    if (props.type.MoneyFields !== undefined && props.type.MoneyFields.includes(item.data)) {
      return moneyHelper.toMoneyFormat(list[item.data], list[props.type.Currency()]);
    } else if (typeof item.data === 'function') {
      return item.data(list);
    }
    return list[item.data];
  };

  const renderTableHeaderCell = (item, Lineindex) => {
    if (item.rolekey && !RoleService.CheckUserPermission('datatable', item.rolekey)) {
      return null;
    }

    if ('block' in item && !props.shownBlocks[item.block].value) return null;

    if (props.hiddenColumns && props.hiddenColumns.has(columnVisibilityHelper.getColumnKey(item, Lineindex)))
      return null;

    const content =
      item.label === '' && item.data !== ''
        ? generateContent(props.itemList, item)
        : typeof item.label === 'function'
        ? item.label()
        : item.label;

    if (item.type === FieldTypesEnum.ActionButton) {
      return (
        <th
          key={`thab${Lineindex}`}
          style={{ width: '44px' }}
        />
      );
    }

    const tablewidth = item.tableminWidth ? item.tableminWidth : undefined;
    const sortable = props.changeOrderBy && item.orderById;
    return (
      <th
        key={`th${Lineindex}`}
        style={{ backgroundColor: item.bgcolor, width: tablewidth }}
        className={sortable ? 'sortable' : undefined}
        onClick={sortable ? () => props.changeOrderBy(item.orderById) : undefined}
      >
        <span className='th-in'>
          {sortable ? item.label : content}
          {sortable &&
            props.orderBy === item.orderById &&
            (props.orderDirection === OrderDirectionsEnum.Asc ? (
              <i className='headerIcon fa-solid fa-caret-up' />
            ) : (
              <i className='headerIcon fa-solid fa-caret-down' />
            ))}
        </span>
      </th>
    );
  };

  if (props.type !== null) {
    return (
      <thead key={'th1'}>
        <tr
          className={`FigmaDetailTableHeader ${props.headerColor}`}
          style={{ visibility: props.DataTableType === 'Body' ? 'collapse' : undefined }}
          key={'tr1'}
        >
          {props.type !== null
            ? props.type.FieldsToShowInDataTable().map((item, Lineindex) => {
                if (props.ModalFeature === true) {
                  if (item.type === FieldTypesEnum.ActionButton || item.type === FieldTypesEnum.DataFieldWithDetails) {
                    return null;
                  }
                } else if (item.type === FieldTypesEnum.Navigation) {
                  return null;
                }
                return renderTableHeaderCell(item, Lineindex);
              })
            : props.FieldsToShowInDataTable.map((item, Lineindex) => renderTableHeaderCell(item, Lineindex))}
        </tr>
      </thead>
    );
  }

  return (
    <thead key={'th2'}>
      <tr
        className={`FigmaDetailTableHeader ${props.headerColor}`}
        key={'tr2'}
      >
        {props.FieldsToShowInDataTable.map((item, Lineindex) => {
          if (
            props.ModalFeature === true &&
            (item.type === FieldTypesEnum.ActionButton || item.type === FieldTypesEnum.DataFieldWithDetails)
          ) {
            return null;
          }
          return renderTableHeaderCell(item, Lineindex);
        })}
      </tr>
    </thead>
  );
}
